import React from 'react';
import RoundImageRender,{RoundImageProps} from './RoundImageRender';

export const RoundImage=({...props}:RoundImageProps):JSX.Element=>{
	return <RoundImageRender {...props}/>;
};
